import { Component, Mixins } from '@/vue-property-decorator'
import AdvertisementBox from '../components/advertisementBox'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import BasePropsConfig from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import FallbackBackground from '../../components/fallbackBackground'
import FavoriteIcon from '../../components/favoriteIcon'
import GameNameVertical from './gameNameVertical'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from '../components/outerBox'
import VirtualBorder from '../../components/virtualBorder'
import _CssVarDefault, { _CssVarManager } from './cssVarDefault'
import _CssVarSmall from './cssVarSmall'
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
export const CssVarDefault = _CssVarDefault
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
export const CssVarSmall = _CssVarSmall
/** 垂直卡片css属性的类型 */
export type VerticalCssVarManager = _CssVarManager

/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<VerticalHk>({
  name: 'VerticalHk'
})
export default class VerticalHk extends Mixins<
  BasePropsConfig,
  // eslint-disable-next-line @typescript-eslint/ban-types
  BaseCssVarInject<{ cssType: '' }, {}>
>(BasePropsConfig, BaseCssVarInject) {
  /** 默认样式 */
  public static CssVarDefault = CssVarDefault
  /** 小号样式 */
  public static CssVarSmall = CssVarSmall
  /** 获得props */
  public static getProps = BasePropsConfig.getProps

  /** 渲染广告图内部 */
  private renderAdvertiseInner() {
    const { isCompleteImage } = this.cardProps
    // 若是一张完整图片,则内部不需要渲染什么内容
    if (isCompleteImage) {
      return undefined
    } else {
      // 如果非上下结构,此处就使用垂直版文字布局
      return (
        <GameNameVertical
          cssVarManager={{ cssType: 'default' }}
        ></GameNameVertical>
      )
    }
  }

  render() {
    const { isMaintain, isFavorited, isShowFavorited } = this.cardProps
    const { status } = this.cardProps

    if (window.wgMock.cardLite) {
      return (
        <OuterBox cssType="default" onClick={this.handleClickCard}>
          <BoxCut>
            <AdvertisementBox
              cssVarManager={{ cssType: 'default' }}
            ></AdvertisementBox>
          </BoxCut>
        </OuterBox>
      )
    }
    return (
      <OuterBox cssType="default" onClick={this.handleClickCard}>
        <BoxCut>
          {/* 兜底背景图 */}
          <FallbackBackground></FallbackBackground>
          {/* 广告图 */}
          <AdvertisementBox cssVarManager={{ cssType: 'default' }}>
            {this.renderAdvertiseInner()}
          </AdvertisementBox>

          <template slot="cutSuspense">
            {/* 游戏状态标签 */}
            {status && <LabelGameStatus />}
            {/* 维护状态悬浮层 */}
            {isMaintain && <MaskMaintain />}
          </template>
          {/* unCut插槽中的元素,不会被overflow:hidden裁剪 */}
          <template slot="unCutSuspense">
            {/* 高亮的虚拟边框 */}
            <VirtualBorder borderUrl={VirtualBorder.getBorderUrlHK()} />
            {isShowFavorited && (
              <FavoriteIcon
                cssVarManager={{ cssType: 'rectangle-star' }}
                isFavorited={isFavorited}
                onClick={this.handleClickFavorIcon}
              >
                <FavoriteIcon.RectangleStar
                  cssVarManager={{ cssType: 'default' }}
                ></FavoriteIcon.RectangleStar>
              </FavoriteIcon>
            )}
          </template>
        </BoxCut>
      </OuterBox>
    )
  }
}
